<template>
  <div
    :class="
      $b({
        showOnDesktop: isCkOrParts || showOnDesktop,
        initial: clickCount < 1,
        loaded,
      })
    "
    :style="highlightStyles"
  >
    <div :class="$b('row-container', { rounded })">
      <div
        ref="tabRow"
        :class="
          $b('row', {
            iconsLinked,
            logosLinked,
            frameSnowLinked,
            frameLinked: bottomFollowFrame,
          })
        "
      >
        <button
          v-for="(tab, idx) in formattedTabs"
          :key="idx"
          :class="
            $b('tab', {
              active:
                activeTabIndex === idx ||
                ((iconsFollowLens || logosFollowLens) &&
                  activeTabIndex === lensesIndex &&
                  (idx === iconsIndex || idx === logosIndex)) ||
                (frameFollowStrap &&
                  activeTabIndex === strapIndex &&
                  idx === frameIndex),
            })
          "
          @click="handleTabClick(idx)"
        >
          <BaseCopy
            tag="span"
            size="h4"
            :class="$b('tab-text')"
          >
            {{ tab.name }}
          </BaseCopy>
        </button>
        <div
          :class="
            $b('button-unlink-container', {
              active: showIconsUnlink || showFrameUnlink,
              icons: showIconsUnlink,
              frame: showFrameUnlink,
            })
          "
        >
          <button
            :class="$b('button-unlink')"
            @click="unlinkParts"
          >
            <VisionIcon
              :class="$b('button-unlink-icon')"
              icon="link"
              colour="black"
              size="x-small"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomiserTabs',
  props: {
    tabs: { type: Array, required: true },
    activeTabIndex: { type: Number, required: true },
    rounded: { type: Boolean, default: false },
    iconsFollowLens: { type: Boolean, default: false },
    logosFollowLens: { type: Boolean, default: false },
    frameFollowStrap: { type: Boolean, default: false },
    bottomFollowFrame: { type: Boolean, default: false },
    showOnDesktop: { type: Boolean, default: false },
    containerWidth: { type: Number, required: true },
    isCkOrParts: { type: Boolean, default: false },
  },
  emits: [
    'update:activeTabIndex',
    'unlink-icons-and-lenses',
    'toggle-frame-strap-link',
    'close-customiser'
  ],
  data() {
    return {
      clickCount: 0,
      loaded: false,
    }
  },
  computed: {
    showShortName() {
      return this.tabs.length > 3
    },
    formattedTabs() {
      return this.tabs.map((tab) => {
        if (tab?.groupName === 'frame') return tab.groupParts[0]
        if (tab?.groupName.toLowerCase() === 'earsocks' && this.showShortName)
          return { ...tab.groupParts[0], name: 'Socks' }
        if (tab?.groupName.toLowerCase() === 'lenses' && this.showShortName)
          return { ...tab.groupParts[0], name: 'Lens' }
        if (tab?.groupName.toLowerCase() === 'bottom' && this.showShortName)
          return { ...tab.groupParts[0], name: 'Base' }
        return tab.groupParts[0]
      })
    },
    highlightStyles() {
      return `
          --highlight-width: ${this.highlightWidth}%;
          --highlight-pos: ${this.highlightPosition};
          --highlight-framelink-pos: ${this.highlightframeLinkPosition};
          --highlight-width-linked: ${this.highlightWidth * 2}%;
        `
    },
    highlightWidth() {
      if (this.isCkOrParts) return 100 / this.tabs.length
      return 100 / this.tabs.length
    },
    highlightPosition() {
      if (this.isCkOrParts)
        return `${
          (this.containerWidth / this.tabs.length) * this.activeTabIndex
        }px`
      return `${
        (this.containerWidth / this.tabs.length) *
        this.activeTabIndex
      }px`
    },
    highlightframeLinkPosition() {
      return `${
        (this.containerWidth / this.tabs.length) *
        (this.activeTabIndex - 1)
      }px`
    },
    partType() {
      return this.tabs[this.activeTabIndex].groupName
    },
    lensesIndex() {
      return this.tabs.findIndex((tab) => tab.groupName === 'lenses')
    },
    iconsIndex() {
      return this.tabs.findIndex((tab) => tab.groupName === 'icons')
    },
    logosIndex() {
      return this.tabs.findIndex((tab) => tab.groupName === 'logos')
    },
    frameIndex() {
      return this.tabs.findIndex((tab) => tab.groupName === 'frame')
    },
    strapIndex() {
      return this.tabs.findIndex((tab) => tab.groupName === 'strap')
    },
    iconsLinked() {
      return (
        (this.partType === 'icons' || this.partType === 'lenses') &&
        this.iconsFollowLens
      )
    },
    logosLinked() {
      return (
        (this.partType === 'logos' || this.partType === 'lenses') &&
        this.logosFollowLens
      )
    },
    frameSnowLinked() {
      return this.partType === 'strap' && this.frameFollowStrap
    },
    showIconsUnlink() {
      return (
        (this.iconsFollowLens || this.logosFollowLens) &&
        this.activeTabIndex === this.lensesIndex
      )
    },
    showFrameUnlink() {
      return this.frameFollowStrap && this.activeTabIndex === this.strapIndex
    },
  },
  watch: {
    tabs(newValue, oldValue) {
      if (newValue.length !== oldValue.length)
        this.$emit('update:activeTabIndex', { idx: 0, part: this.tabs[0].groupName })
    },
    iconsFollowLens() {
      if (this.iconsFollowLens && this.activeTabIndex === this.iconsIndex)
        this.$emit('update:activeTabIndex', {
          idx: this.lensesIndex,
          part: this.tabs[this.lensesIndex].groupName,
        })
    },
    logosFollowLens() {
      if (this.logosFollowLens && this.activeTabIndex === this.logosIndex)
        this.$emit('update:activeTabIndex', {
          idx: this.lensesIndex,
          part: this.tabs[this.lensesIndex].groupName,
        })
    },
    frameFollowStrap() {
      if (this.frameFollowStrap && this.activeTabIndex === this.frameIndex)
        this.$emit('update:activeTabIndex', {
          idx: this.strapIndex,
          part: this.tabs[this.strapIndex].groupName,
        })
    },
    activeTabIndex() {
      this.clickCount++
    },
  },
  mounted() {
    this.loaded = true
  },
  methods: {
    handleTabClick(idx) {
      let nextIdx = idx
      if (this.iconsFollowLens && idx === this.iconsIndex)
        nextIdx = this.lensesIndex
      if (this.logosFollowLens && idx === this.logosIndex)
        nextIdx = this.lensesIndex
      if (this.frameFollowStrap && idx === this.frameIndex)
        nextIdx = this.strapIndex
      this.$emit('update:activeTabIndex', {
        idx: nextIdx,
        part: this.tabs[nextIdx].groupName,
      })
    },
    unlinkParts() {
      if (this.iconsFollowLens || this.logosFollowLens)
        this.$emit('unlink-icons-and-lenses')
      if (this.frameFollowStrap) this.$emit('toggle-frame-strap-link')
    },
  },
}
</script>

<style lang="postcss">
.CustomiserTabs {
  @apply w-full z-0 md:hidden;

  &--show-on-desktop {
    @apply block;
  }
}

.CustomiserTabs__row-container {
  @apply relative
    w-full z-0;

  &--rounded {
    @apply rounded-lg;
  }
}

.CustomiserTabs__row {
  @apply relative
    inline-flex items-center gap-1 justify-evenly flex-shrink
    w-full z-0;

  &--icons-linked,
  &--logos-linked {
    &::before {
      width: var(--highlight-width-linked);
    }
  }

  &--frame-snow-linked {
    &::before {
      transform: translate3d(var(--highlight-framelink-pos), 0, 0);
      width: var(--highlight-width-linked);
    }
  }
}

.CustomiserTabs__tab {
  @apply text-off-black text-center
    flex justify-center items-center
    py-2 px-1
    border border-grey-400
    rounded-lg;

  -webkit-tap-highlight-color: transparent;
  flex: 1 1 100%;
  appearance: none;
  z-index: 2;

  &:last-of-type {
    @apply pr-0;
  }

  &:focus {
    outline: none;
  }

  &:hover:not(&--active):not(&--save) {
    @apply opacity-100 md:opacity-60;
  }

  &--save {
    @apply text-white cursor-pointer relative;
    z-index: 2;
    transform: translate3d(3px, 0, 0);

    &::before {
      @apply absolute transition-all duration-300 ease-in-out;
      content: '';
      background-size: 125% 100%;
      background-position: 50% 0;
      background-image: var(--gradient-custom);
      border-radius: 20px;
      height: calc(100% - theme('spacing.xxxs'));
      width: calc(100% - 6px);
      z-index: 1;
    }

    .CustomiserTabs__tab-text {
      @apply relative;
      z-index: 2;
    }

    &:hover {
      &::before {
        background-position: 0;
      }
    }
  }

  &--active {
    @apply border border-black;
  }
}

.CustomiserTabs__tab-text {
  @apply text-xs xxs:text-sm normal-case;
}

.CustomiserTabs__button-unlink-container {
  @apply absolute bg-transparent left-0 z-10 text-center
    opacity-0;
  -webkit-tap-highlight-color: transparent;
  width: var(--highlight-width-linked);
  transform: translate3d(var(--highlight-pos), 0, 0);
  left: -1000px;

  &--active {
    @apply block left-0 opacity-100 top-0 bottom-0;

    .CustomiserTabs__button-unlink {
      @apply border-y border-black;
    }
  }

  &--frame.CustomiserTabs__button-unlink-container--active {
    transform: translate3d(var(--highlight-framelink-pos), 0, 0);
  }
}

.CustomiserTabs__button-unlink {
  @apply inline-flex items-center justify-center bg-white h-full aspect-square;

  -webkit-tap-highlight-color: transparent;
}

.CustomiserTabs__button-unlink-icon {
  @apply opacity-0 transition-opacity;

  .CustomiserTabs__button-unlink-container--active & {
    @apply opacity-100;
    transition-duration: 0.3s;
    transition-delay: 0.1s;
  }
}
</style>
